import { Formulas, FormulaTypes } from "../../formula/models/formula.model";

export enum SubscriptionIntervals {
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  SEMESTER = "SEMESTER",
  YEARLY = "YEARLY",
  LIFETIME = "LIFETIME",
}

export interface HistoricalSubscriptionOffer {
  name: string;
  is_legacy: boolean;
  amount: number | null;
  currency: string;
  interval: SubscriptionIntervals;
  employee_limit: number | null;
  accountant_limit: number | null;
}

export class EvaSubscription {
  subscription_id: string;
  pending_signup_email?: string;
  eva_company_id: string;
  formula_type: FormulaTypes;
  formula: Formulas;
  interval: SubscriptionIntervals; //MONTHLY, YEARLY, LIFETIME
  status: string; // ACTIVE, INACTIVE
  trial_start_date: Date;
  trial_end_date: Date;
  trial_days_left: number;
  trial_grace_delay_used: boolean;
  onboarding_start_date: Date;
  onboarding_end_date: Date;

  stripe_customer_id: string;
  stripe_subscription_id: string;
  stripe_price_id?: string;
  billing_formula?: string;
  historical_offer?: HistoricalSubscriptionOffer | null;
  stripe_current_period_start: Date;
  stripe_current_period_end: Date;
  stripe_canceled_at: Date;
  stripe_custom_subscription: any;

  env: string;
  front_url_redirect: string;
  mrr: number;
  arr: number;
  lifetime_amount: number;
  currency?: string;

  max_employees_accounts: number;
  max_accountants_accounts: number;

  formula_overage_blocked: boolean;

  public static createInstance(jsonData: any): EvaSubscription {
    const s = Object.assign(new EvaSubscription(), jsonData);
    if (s.trial_start_date) s.trial_start_date = new Date(s.trial_start_date);
    if (s.trial_end_date) s.trial_end_date = new Date(s.trial_end_date);
    if (s.onboarding_start_date) s.onboarding_start_date = new Date(s.onboarding_start_date);
    if (s.onboarding_end_date) s.onboarding_end_date = new Date(s.onboarding_end_date);
    if (s.stripe_current_period_start) s.stripe_current_period_start = new Date(s.stripe_current_period_start);
    if (s.stripe_current_period_end) s.stripe_current_period_end = new Date(s.stripe_current_period_end);
    if (s.stripe_canceled_at) s.stripe_canceled_at = new Date(s.stripe_canceled_at);
    return s;
  }

  public static createInstances(jsonData: any[]): EvaSubscription[] {
    return jsonData.map(EvaSubscription.createInstance);
  }

  get on_trial(): boolean {
    return this.status === "TRIAL";
  }

  isOnboardingActive(): boolean {
    if (this.status !== "ACTIVE" || !this.onboarding_start_date || !this.onboarding_end_date) {
      return false;
    }
    const today = new Date();
    return this.onboarding_start_date <= today && today <= this.onboarding_end_date;
  }

  hasAccessToPlanning(): boolean {
    if (this.formula_type === "EXPERT") return true;
    return false;
  }

  hasAccessToProjects(): boolean {
    return true;
  }

  hasAccessToAssets(): boolean {
    return true;
  }

  hasAccessToPurchases(): boolean {
    return true;
  }

  hasAccessToAudits(): boolean {
    if (this.formula_type === "EXPERT") return true;
    return false;
  }

  hasAccessToWorkingActivities(): boolean {
    if (this.formula_type === "EXPERT") return true;
    return false;
  }

  hasAccessToBudget(): boolean {
    return true;
  }

  hasAccessToCollaborators(): boolean {
    return true;
  }

  hasAccessToExpenseReports(): boolean {
    if (this.formula_type === "EXPERT") return true;
    return false;
  }

  hasAccessToAccounting(): boolean {
    return true;
  }

  hasAccessToContacts(): boolean {
    if (this.formula_type === "EXPERT") return true;
    return false;
  }

  hasAccessToTasks(): boolean {
    if (this.formula_type === "EXPERT") return true;
    return false;
  }
}
